import {cleanUpInScope, initInScope, onFind} from "@elements/init-modules-in-scope";
import {removeClass,hasClass,on,closest,findIn, findAllIn } from '@elements/dom-utils';

const selectors = {
    base: '.js-add-row',
    table: '.js-add-row__table',
    btn: '.js-add-row__btn',
    row: '.js-add-row__row',
    deleteBtn: '.js-add-row__delete',
    deleteBtnNew: '.js-add-row__delete-new'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let btn = findIn(selectors.btn, baseElement);
        let table = findIn(selectors.table, baseElement);
        let row = findIn(selectors.row, baseElement);
        let deleteBtn = findAllIn(selectors.deleteBtn, baseElement);
        let deleteBtnNew;

        on("click", function () {
            if (hasClass('d-none', table)) {
                removeClass('d-none', table);
            }

            let counter = btn.getAttribute("data-counter");
            let clone = row.content.cloneNode(true);
            let rowClone = clone.firstElementChild;

            let inputFields = findAllIn('.js-add-row__input', rowClone);
            inputFields.forEach((inputField) => {
                inputField.setAttribute("id", inputField.getAttribute("id") + '[' + counter + '][' + inputField.getAttribute('data-input') + ']');
                inputField.setAttribute("name", inputField.getAttribute("name") + '[' + counter + '][' + inputField.getAttribute('data-input') + ']');
            })
            let deleteBtnsNew = findAllIn('.js-add-row__delete-new', rowClone);
            deleteBtnsNew.forEach((deleteBtn) => {
                deleteBtn.setAttribute("data-row-index", counter);
            })

            rowClone.setAttribute("data-row-index", counter);
            let body = table.getElementsByTagName("tbody")[0];

            body.appendChild(clone); // We are adding at the end
            counter++;

            btn.setAttribute("data-counter", counter);

            deleteRow(deleteBtnsNew, ".js-add-row__row", table)

            cleanUpInScope(baseElement);
            initInScope(baseElement);
        }, btn)

        deleteRow(deleteBtn, ".js-add-row__delete-row", table)
    });
}

function deleteRow(buttons, rowClass, table){
    buttons.forEach((btn) => {
        on("click", function () {
            let deleteID = btn.getAttribute("data-row-index");
            let rowToDelete = closest(rowClass, btn);

            if (deleteID === rowToDelete.getAttribute("data-row-index")){
                rowToDelete.nextElementSibling.remove();
                rowToDelete.remove();
            }
        }, btn)
    })
}
